import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Creators as NewGridPeriodCreators } from '~/redux/ducks/newGridPeriod';
import { Creators as ConfirmModalActions } from '~/redux/ducks/confirmModal';

import {
  ButtonGridPeriodIcon,
  ChannelsIcon,
  InspectChannelIcon,
  AwaitingStatusIcon,
  ProcessingStatusIcon,
  ValidatedStatusIcon,
} from '../Components';

import {
  Container,
  Header,
  StyledDiv,
  GroupElements,
  GroupTitleList,
  Select,
  Button,
  Table,
} from './styles';
import { ModalInitCloseWeekly, ModalChannel, ModalScheduleConfiguration } from './Components';

function NewGridPeriodList({
  periods, periodSelected, zones, gridPeriodSetup, openModalInitCloseWeekly, openModalChannel,
  changePeriodSelected, confirmModal, confirmCloseGridPeriod, restartGridPeriod, importCampaignsCsv,
  openModalScheduleConfiguration,
}) {
  const [gridOpen, setGridOpen] = useState(false);
  const [modeInit, setModeInit] = useState(false);
  const [disabledConfirmCloseWeekly, setDisabledConfirmCloseWeekly] = useState(true);
  const [disabledImportCsv, setDisabledImportCsv] = useState(true);

  const handleConfirmCloseWeekly = useCallback(() => {
    const handleConfirmClose = async () => {
      confirmCloseGridPeriod();
    };

    confirmModal(
      'Você confirma a conclusão do fechamento semanal?',
      periodSelected.label,
      handleConfirmClose,
    );
  }, [periodSelected, confirmCloseGridPeriod, confirmModal]);

  const handleRestartGridPeriod = useCallback(() => {
    if (!periodSelected) return;

    const handleConfirmRestart = () => {
      restartGridPeriod(periodSelected.uuid);
    };

    confirmModal(
      'Você confirma o reinício do período de grid?',
      periodSelected.label,
      handleConfirmRestart,
    );
  }, [periodSelected, restartGridPeriod, confirmModal]);

  const handleImportCsv = useCallback(() => {
    if (disabledImportCsv) return;

    const fileInput = document.getElementById('csv-file-input');
    if (fileInput) {
      fileInput.click();
    }
  }, [disabledImportCsv]);

  const handleFileChange = useCallback((event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (!file.name.toLowerCase().endsWith('.csv')) {
      // Aqui poderia mostrar um toast de erro, mas como não temos acesso direto,
      // vamos apenas retornar
      return;
    }

    const handleConfirmImport = () => {
      importCampaignsCsv(periodSelected.uuid, file);
    };

    confirmModal(
      'Você confirma a importação do CSV de campanhas?',
      `Arquivo: ${file.name}`,
      handleConfirmImport,
    );

    // Limpar o input para permitir selecionar o mesmo arquivo novamente
    event.target.value = '';
  }, [periodSelected, importCampaignsCsv, confirmModal]);

  const handleOpenModalInitCloseWeekly = useCallback(() => {
    openModalInitCloseWeekly();
  }, [openModalInitCloseWeekly]);

  useEffect(() => {
    if (periodSelected) {
      setGridOpen(periodSelected.gridOpen);
      if (periodSelected.gridOpen) {
        const isExistZoneNotStatus = zones.find(z => z.status === 'NOT_STATUS');
        if (isExistZoneNotStatus || !zones.length) {
          setModeInit(true);
        } else {
          setModeInit(false);
        }
        const isNotDoneZones = zones.find(z => z.status !== 'DONE');
        if (!isNotDoneZones) {
          setDisabledConfirmCloseWeekly(false);
        }

        const allZonesAnalyzing = zones.length > 0 && zones.every(z => z.status === 'ANALYZING');
        setDisabledImportCsv(!allZonesAnalyzing);
      }
    } else {
      setModeInit(false);
      setGridOpen(false);
      setDisabledImportCsv(true);
    }
  }, [periodSelected, zones]);

  useEffect(() => {
    gridPeriodSetup();
  }, []);

  function getStatusIcon(status) {
    switch (status) {
      case 'NOT_STATUS':
        return <AwaitingStatusIcon />;
      case 'ANALYZING':
        return <ProcessingStatusIcon />;
      case 'DONE':
        return <ValidatedStatusIcon />;
      default:
        return <AwaitingStatusIcon />;
    }
  }

  function getStatusDescription(status) {
    switch (status) {
      case 'NOT_STATUS':
        return <span className="span-awaiting">Aguardando abertura análise</span>;
      case 'ANALYZING':
        return <span className="span-analysis">Em análise</span>;
      case 'DONE':
        return <span className="span-validated">Validado</span>;
      default:
        return <span className="span-awaiting">Aguardando abertura análise</span>;
    }
  }

  return (
    <Container>
      <Header>
        <h1>FECHAMENTO SEMANAL</h1>
        {/* {gridOpen && !modeInit && (
          <Button bordered>
            <ButtonConfigIcon />
            <span>Configurações de Fechamento</span>
          </Button>
        )} */}
      </Header>
      <StyledDiv>
        <GroupElements>
          <Select
            id="period"
            name="period"
            className="react-select-container"
            classNamePrefix="react-select"
            options={periods}
            value={periodSelected ? periods.find(p => p.value === periodSelected.uuid) : null}
            onChange={e => changePeriodSelected(e.item)}
          />
          {gridOpen && modeInit && (
            <Button onClick={handleOpenModalInitCloseWeekly}>
              <ButtonGridPeriodIcon />
              <span>Iniciar análise de fechamento semanal</span>
            </Button>
          )}
          {gridOpen && !modeInit && (
            <div style={{ display: 'flex', gap: '10px' }}>
              <Button
                onClick={handleRestartGridPeriod}
                style={{ marginLeft: '10px', backgroundColor: '#dc3545', borderColor: '#dc3545' }}
              >
                <ButtonGridPeriodIcon />
                <span>Reiniciar período</span>
              </Button>
              <Button
                disabled={disabledImportCsv}
                onClick={handleImportCsv}
                style={{
                  backgroundColor: disabledImportCsv ? '#a8d5a8' : '#28a745',
                  borderColor: disabledImportCsv ? '#a8d5a8' : '#28a745',
                }}
              >
                <ButtonGridPeriodIcon />
                <span>Importar CSV</span>
              </Button>
              <Button disabled={disabledConfirmCloseWeekly} onClick={handleConfirmCloseWeekly}>
                <ButtonGridPeriodIcon />
                <span>Confirmar fechamento semanal</span>
              </Button>
            </div>
          )}
        </GroupElements>
      </StyledDiv>
      <StyledDiv bordered>
        <GroupTitleList>
          <ChannelsIcon />
          <h3>CANAIS</h3>
        </GroupTitleList>
        <Table>
          <tbody>
            {zones.map((zone) => {
              const auction = zone.types.find(t => t.name === 'AUCTION');
              const fixedCpa = zone.types.find(t => t.name === 'FIXED_CPA');
              const probe = zone.types.find(t => t.name === 'PROBE');
              const bonus = zone.types.find(t => t.name === 'BONUS');
              return (
                <tr key={zone.uuid}>
                  <td style={{ minWidth: 250 }}>{`${zone.channel.name} (${zone.name})`}</td>
                  <td style={{ width: 180 }}>
                    <div>
                      <span>Leilão</span>
                      {getStatusIcon(auction.status)}
                    </div>
                  </td>
                  <td style={{ width: 180 }}>
                    <div>
                      <span>Teste</span>
                      {getStatusIcon(probe.status)}
                    </div>
                  </td>
                  <td style={{ width: 180 }}>
                    <div>
                      <span>CPA Fixo</span>
                      {getStatusIcon(fixedCpa.status)}
                    </div>
                  </td>
                  <td style={{ width: 180 }}>
                    <div>
                      <span>Bonificada</span>
                      {getStatusIcon(bonus.status)}
                    </div>
                  </td>
                  <td style={{ width: 250 }}>
                    <div>
                      <span>Situação Canal</span>
                      <div className="channel-situation">
                        {getStatusIcon(zone.status)}
                        {getStatusDescription(zone.status)}
                      </div>
                    </div>
                  </td>
                  <td style={{ width: 180 }}>
                    <div style={{ display: 'flex', gap: '10px', flexDirection: 'row', justifyContent: 'end' }}>
                      {zone.status === 'DONE' && (
                        <Button
                          onlyIcon
                          onClick={() => openModalScheduleConfiguration(zone)}
                          style={{ backgroundColor: '#17a2b8', borderColor: '#17a2b8' }}
                          title="Configurar Schedule"
                        >
                          <ButtonGridPeriodIcon />
                        </Button>
                      )}
                      <Button onlyIcon onClick={() => openModalChannel(zone)}>
                        <InspectChannelIcon />
                      </Button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </StyledDiv>
      <ModalInitCloseWeekly />
      <ModalChannel />
      <ModalScheduleConfiguration isEditable={gridOpen && !modeInit} />
      <input
        id="csv-file-input"
        type="file"
        accept=".csv"
        onChange={handleFileChange}
        style={{ display: 'none' }}
      />
    </Container>
  );
}

const mapStateToProps = ({
  newGridPeriod: {
    showModalInitCloseWeekly,
    periods,
    periodSelected,
    zones,
  },
}) => ({
  showModalInitCloseWeekly,
  periods: periods.map(p => ({
    value: p.uuid,
    label: p.label,
    item: p,
  })),
  periodSelected,
  zones,
});


const mapDispatchToProps = dispatch => bindActionCreators(
  {
    gridPeriodSetup: NewGridPeriodCreators.gridPeriodSetup,
    changePeriodSelected: NewGridPeriodCreators.changePeriodSelected,
    openModalInitCloseWeekly: NewGridPeriodCreators.openModalInitCloseWeekly,
    openModalChannel: NewGridPeriodCreators.openModalChannel,
    confirmCloseGridPeriod: NewGridPeriodCreators.confirmCloseGridPeriod,
    restartGridPeriod: NewGridPeriodCreators.restartGridPeriod,
    importCampaignsCsv: NewGridPeriodCreators.importCampaignsCsv,
    openModalScheduleConfiguration: NewGridPeriodCreators.openModalScheduleConfiguration,

    confirmModal: ConfirmModalActions.showConfirmModal,
  },
  dispatch,
);

NewGridPeriodList.defaultProps = {
  periods: [],
  periodSelected: null,
  zones: [],
};

NewGridPeriodList.propTypes = {
  confirmModal: PropTypes.func.isRequired,
  gridPeriodSetup: PropTypes.func.isRequired,
  openModalInitCloseWeekly: PropTypes.func.isRequired,
  openModalChannel: PropTypes.func.isRequired,
  changePeriodSelected: PropTypes.func.isRequired,
  confirmCloseGridPeriod: PropTypes.func.isRequired,
  restartGridPeriod: PropTypes.func.isRequired,
  importCampaignsCsv: PropTypes.func.isRequired,
  openModalScheduleConfiguration: PropTypes.func.isRequired,
  periods: PropTypes.arrayOf(PropTypes.shape()),
  periodSelected: PropTypes.shape(),
  zones: PropTypes.arrayOf(PropTypes.shape()),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NewGridPeriodList);
